import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Nav } from 'react-bootstrap';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import AppContext from '../../context/Context';
import { metaBackends } from '../../../../meta';

function NavbarNavLink({ title, route }) {
  const {
    config: { navbarCollapsed, showBurgerMenu },
    setConfig,
  } = useContext(AppContext);
  const active = route && route.resource in metaBackends;

  const handleClick = () => {
    if (navbarCollapsed) {
      setConfig('navbarCollapsed', !navbarCollapsed);
    }
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };
  return (
    <Nav.Link
      as={title ? 'p' : Link}
      className={classNames('fw-medium text-no1wrap ', {
        'text-500': !active,
        'text-700 mb-0 fw-bold': title,
        'py-1': !title,
        'link-600': !title && active,
      })}
      to={active ? metaBackends[route.resource].frontendURL : ''}
      onClick={handleClick}
    >
      {title || route.label}
    </Nav.Link>
  );
}

NavbarNavLink.propTypes = {
  title: PropTypes.string,
  route: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    resource: PropTypes.string.isRequired,
  }),
};

NavbarNavLink.defaultProps = {
  title: '',
  route: null,
};

export default NavbarNavLink;
